/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geotiercity2Inputs */

const en_geotiercity2 = /** @type {(inputs: Geotiercity2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`City`)
};

const de_geotiercity2 = /** @type {(inputs: Geotiercity2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stadt`)
};

/**
* | output |
* | --- |
* | "City" |
*
* @param {Geotiercity2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const geotiercity2 = /** @type {((inputs?: Geotiercity2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geotiercity2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geotiercity2(inputs)
	return de_geotiercity2(inputs)
});
export { geotiercity2 as "geoTierCity" }